<template>
  <div class="advantages d_flex justify_content_sb bc_fff">

    <div class="d_flex align_item_c">
      <span>
        <img src="@/assets/images/advantages_4.png" alt="">
      </span>
      <span class="span_1 fz24">运营规范</span>
    </div>

    <div class="d_flex align_item_c">
      <span>
        <img src="@/assets/images/advantages_3.png" alt="">
      </span>
      <span class="span_1 fz24">操作简洁</span>
    </div>

    <div class="d_flex align_item_c">
      <span>
        <img src="@/assets/images/advantages_2.png" alt="">
      </span>
      <span class="span_1 fz24">公开透明</span>
    </div>

    <div class="d_flex align_item_c">
      <span>
        <img src="@/assets/images/advantages_1.png" alt="">
      </span>
      <span class="span_1 fz24">安全可靠</span>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.advantages{
    padding: 20px 65px;
    margin: 10px 0;
border: 1px solid #E6E6E6;
    .span_1{
        margin: 0 0 0 10px;
    }
}
</style>
